import { useCallback, type FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { JiraIcon } from '@atlaskit/logo';
import { boardSwitcherSharedState } from '@trello/board-switcher';
import { useJwmLinkNavigationData } from '@trello/jwm';
import { useSharedStateSelector } from '@trello/shared-state';

import { JwmLinkedWorkspace } from 'app/src/components/WorkspaceNavigation/JwmLinkedWorkspace';
import { ExpandSection } from './ExpandSection';

import * as styles from './JiraProjects.module.less';

interface JiraProjectsProps {
  workspaceId: string;
}

export const JiraProjects: FunctionComponent<JiraProjectsProps> = ({
  workspaceId,
}) => {
  const expandSectionsState = useSharedStateSelector(
    boardSwitcherSharedState,
    useCallback((state) => state.expandSectionsState, []),
  );
  const jwmLinkNavigationData = useJwmLinkNavigationData(workspaceId);

  const title = (
    <>
      <JiraIcon size="small" label="" />
      <FormattedMessage
        id="templates.board_switcher.jira-projects"
        defaultMessage="Jira Projects"
        description="Title of the Jira projects section of a workspace on the board switcher"
      />
    </>
  );

  const expandSectionId = `jira-projects-${workspaceId}`;
  const isExpandedByDefault = expandSectionsState[expandSectionId] ?? false;

  if (jwmLinkNavigationData.jwmSiteUrl) {
    return (
      <ExpandSection
        key={expandSectionId}
        id={expandSectionId}
        title={title}
        isExpandedByDefault={isExpandedByDefault}
      >
        <div className={styles.jiraProjects}>
          <JwmLinkedWorkspace
            workspaceId={workspaceId}
            jwmLinkNavigationData={jwmLinkNavigationData}
          />
        </div>
      </ExpandSection>
    );
  }

  return null;
};
